// Endpoints
import { typesEndpoint } from '../../../common/types';

// Utils
import { getApiRequest } from '../../../utils';

export const apiGetNotas = async () => {
  return getApiRequest({
    url: typesEndpoint.blog,
  });
};
